module.exports = __webpack_public_path__ + "static/school_obj4@2x-05b4255f37f061556ce626baa13e23a7.png";